<template>
    <div :class="[isError ? 'mb-3' : 'mb-6']">
        <div class="font-bold text-xl"
            :class="[isError ? 'text-red-500' : 'text-black']"
            v-if="inputLbl.name">
            {{inputLbl.name}}<span class="text-red-500" v-if="inputLbl.required">*</span>
        </div>
        <div class="relative">
            <input type="text"
                class="w-full border bg-white px-3 py-2.5 placeholder-tc-gray-1 rounded-10 text-20 text-a-blue-1c3e95"
                v-model="content"
                :placeholder="placeholder"
                :maxlength="inputMaxLength"
                @input="onChange()" />
            <!-- <div class="absolute top-1/2 right-4 transform -translate-y-2/4 text-xl"
                v-if="isShowRemove"
                @click="onRemove()">
                X
            </div> -->
        </div>
        <div class="text-red-500 text-xl mt-1.5"
            v-if="isError">
            {{getErrorMsg}}
        </div>
    </div>
</template>
<script>
// helper
import RegxHelper from "@/helper/RegxHelper.js";
import Util from "@/helper/Utility.js";
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'InputCollectPoint',
    mixins: [LocaleMixin],
    props: {
        // v-model
        inputValid:     { type: Boolean },
        inputValue:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isShowRemove:   { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        delimeter:      { type: String, default: '' },
        // text
        inputIndex:     { type: Number, required: true },
        inputLbl:       { type: Object, required: true }
    },
    data: function () {
        return {
            content: this.inputValue,
            inputMaxLength: null,
            placeholder: '',
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    watch: {
        inputValue: function (newVal) {
            this.content = newVal;
        }
    },
    created: function () {
        //this.placeholder = Util.stringFormat(this.inputLbl.placeholder, (this.inputIndex + 1));
        this.placeholder = this.lbl.getfriend.enter_contact;
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function () {
        this.validateInput();
    },
    methods: {
        // event
        onChange: function () {
            let input = Util.isEmptyStr(this.content) ? '' : this.content;
            input = RegxHelper.removeEmoji(input);
            input = input.replace(/^[^0].*/, '');
            input = RegxHelper.removeNotNumber(input);

            // if (!Util.isEmptyStr(this.delimeter)) {
            let n1, n2, n3;
            if (input.length <= 3) {
                // do nothing
            } else if (input.length <= 6) {
                n1 = input.substr(0, 3);
                n2 = input.substr(3, 3);
                input = n1 + this.delimeter + n2;
            } else {
                n1 = input.substr(0, 3);
                n2 = input.substr(3, 3);
                n3 = input.substr(6);
                input = n1 + this.delimeter + n2 + this.delimeter + n3;
            }
            // }

            this.content = input;
            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },
        onRemove: function () {
            this.$emit('onRemove', this.inputIndex)
        },
        // method
        validateInput: function () {
            if (!this.inputLbl) return;

            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            //Required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short
                && this.minLength
                && this.content
                && this.content.length < this.minLength) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }

            this.$emit('update:inputValid', this.errorInfo.isValid);
        }
    }
}
</script>
